let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lRtGG"), load("8JZKd"), load("2UhBp")]).then(() => parcelRequire('lk4NH'));